import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgMyBookings = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 20,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0a4 4 0 0 1 3.995 3.8L14 4h3a3 3 0 0 1 3 3v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a3 3 0 0 1 3-3h3a4 4 0 0 1 4-4Zm7 5h-3v2h-1V5H7v2H6V5H3a2 2 0 0 0-1.995 1.85L1 7v10h18V7a2 2 0 0 0-1.85-1.995L17 5Zm-7-4a3 3 0 0 0-2.995 2.824L7 4h6a3 3 0 0 0-3-3Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgMyBookings;